import script from "./VideoMeetingAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoMeetingAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./VideoMeetingAttachment.vue?vue&type=style&index=0&id=08ec20eb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ec20eb"]])

export default __exports__